import { formatDateAndTime } from '../../utils/stringUtils'
import { TerminalDto, TerminalEventDtoNewStateEnum } from '../../../generated-api'

const TerminalDetailsTab = ({ terminal }: { terminal: TerminalDto }) => (
    <div className="rounded-lg rounded-tl-none bg-brand-white shadow-lg py-5 px-5 max-w-4xl">
        <table className="text-left mt-5">
            <tbody>
                <tr>
                    <th className="pr-5 py-2">PSP terminal ID</th>
                    <td>
                        <div className="flex items-center">{terminal.pspTerminalId}</div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Name</th>
                    <td>
                        <div className="flex items-center">{terminal.name}</div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Terminal state</th>
                    <td>
                        <div className="flex items-center">
                            <span
                                className={`rounded-full w-0 inline-block p-2 mr-2 ${
                                    terminal.latestState === TerminalEventDtoNewStateEnum.OK
                                        ? 'bg-green-dark'
                                        : terminal.latestState === TerminalEventDtoNewStateEnum.MAINTENANCE ||
                                          terminal.latestState === TerminalEventDtoNewStateEnum.BUSY
                                        ? 'bg-yellow-light'
                                        : 'bg-orange'
                                }`}
                            />
                            <span>{terminal.latestState}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Battery level</th>
                    <td>
                        <div className="flex items-center">{terminal.batteryLevel}</div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Battery level updated</th>
                    <td>
                        {terminal.batteryLevelUpdated ? formatDateAndTime(terminal.batteryLevelUpdated.toString()) : ''}
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Created in database</th>
                    <td>{formatDateAndTime(terminal.created?.toString() ?? '')}</td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Updated in database</th>
                    <td>{formatDateAndTime(terminal.updated?.toString() ?? '')}</td>
                </tr>
            </tbody>
        </table>
    </div>
)

export default TerminalDetailsTab
